import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { router } from './App';
import { RouterProvider } from 'react-router-dom';
import { Toaster } from "react-hot-toast";
import { initAnalytics } from './utils/analytics';

// Initialize Google Tag Manager & Microsoft Clarity
initAnalytics();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <>
    <Toaster position="bottom-right" toastOptions={{
      duration: 6000
    }} />
    <RouterProvider router={router} />
  </>
);

